<template>
    <nav class="navbar is-dark" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
            <a class="navbar-item">
                <img class="logo" src="@/assets/rafiki.png" />
            </a>
        </div>

        <div class="navbar-menu">
            <div class="navbar-start">
                <div class="navbar-item has-dropdown is-hoverable">
                    <a class="navbar-link">
                        <div class="menu-item-label">
                            <span>Dashboard</span>
                            <span class="tag is-light menu-item-label-context">
                                {{ selectedDashboardLabel }}
                            </span>
                        </div>
                    </a>

                    <div class="navbar-dropdown">
                        <a
                            v-for="dashboard in dashboards"
                            :key="dashboard.id"
                            class="navbar-item"
                            :class="{ 'is-active': selectedDashboard === dashboard.id }"
                            @click="setDashboard(dashboard.id)"
                        >
                            {{ dashboard.label }}
                        </a>
                    </div>
                </div>
                <div class="navbar-item has-dropdown is-hoverable">
                    <a class="navbar-link">
                        <div class="menu-item-label">
                            <span>Terminals</span>
                            <span class="tag is-light menu-item-label-context">
                                {{ selectedTerminals.length }} Selected
                            </span>
                        </div>
                    </a>

                    <div class="navbar-dropdown">
                        <TerminalSelector
                            :terminals="terminals"
                            :countries="countries"
                            :setSelectedTerminals="setSelectedTerminals"
                            :selectedTerminals="selectedTerminals"
                        />
                    </div>
                </div>
            </div>

            <div class="navbar-end">
                <div class="navbar-item">
                    <div class="buttons">
                        <a @click="logout()" class="button is-danger">Logout</a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>
<script>
import { auth } from '@/auth'
import TerminalSelector from '@/widgets/TerminalSelector'

export default {
    name: 'TopNavigation',
    components: { TerminalSelector },
    props: {
        dashboards: Array,
        selectedDashboard: String,
        setDashboard: Function,
        terminals: Array,
        countries: Array,
        setSelectedTerminals: Function,
        selectedTerminals: Array,
    },
    computed: {
        selectedDashboardLabel() {
            const { dashboards, selectedDashboard } = this.$props
            const label = dashboards
                .filter((dashboard) => dashboard.id === selectedDashboard)
                .map((dashboard) => dashboard.label)[0]
            return label || ''
        },
    },
    methods: {
        logout() {
            auth.clear()
            this.$router.push({ name: 'login' })
        },
    },
}
</script>
<style lang="scss" scoped>
.logo {
    margin-right: 5px;
    border-radius: 5px;
}

.menu-item-label {
    display: flex;
    flex-direction: column;
}

.menu-item-label-context {
    opacity: 0.5;
}
</style>
